import { b } from './chunk-IMSWER4T.js';

var r=class extends b{URL="imports";async restartImport(e){return await(await this._client.post("/imports/restart",e)).data}};

export { r as a };
//# sourceMappingURL=chunk-CBQH5DH5.js.map
//# sourceMappingURL=chunk-CBQH5DH5.js.map